import React, { FunctionComponent, ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Button
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import styles from "./CustomDialog.module.css";

interface CustomDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string; // Optional subtitle
  children: ReactNode;
  actions?: ReactNode; // If provided, renders custom actions area. Otherwise default? Or maybe Actions are children?
                       // Actually, the screenshots show specific "No/Yes" or "Cancel/Submit". Let's pass actions as prop.
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  showCloseIcon?: boolean;
  paperProps?: object; // Allow passing specific styles like borderRadius
}

const CustomDialog: FunctionComponent<CustomDialogProps> = ({ 
  open, 
  onClose, 
  title, 
  subtitle, 
  children, 
  actions, 
  maxWidth = "sm", 
  showCloseIcon = false,
  paperProps = { sx: { borderRadius: '15px' } }
}) => {
  return (
    <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth={maxWidth} 
        fullWidth 
        PaperProps={paperProps}
    >
        {showCloseIcon && (
            <div className={styles.closeIconWrapper}>
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </div>
        )}
        <DialogContent className={styles.dialogContent}>
            <Typography variant="h6" className={styles.dialogTitle}>{title}</Typography>
            {subtitle && <Typography variant="body2" className={styles.dialogSub}>{subtitle}</Typography>}
            
            {children}

            {actions && (
                <div className={styles.dialogActions}>
                    {actions}
                </div>
            )}
        </DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
